import Seo from './Seo'
import { abs, breadcrumbJsonLd, DEFAULT_OG_IMAGE, SITE } from '../../lib/seo'
import type { BlogPost } from '../../lib/blog/types'

/** SEO head for a single blog post: BlogPosting + BreadcrumbList JSON-LD. */
export default function BlogSeo({ post }: { post: BlogPost }) {
  const path = `/blog/${post.slug}`
  const image = post.hero_image ? abs(post.hero_image) : DEFAULT_OG_IMAGE

  // The org name is "BankStatementReader Team"; a named human writer would be a Person.
  const ORG_NAME = 'BankStatementReader Team'
  const author =
    post.author === ORG_NAME
      ? { '@type': 'Organization', name: post.author }
      : { '@type': 'Person', name: post.author }

  const blogPosting = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.description,
    image,
    datePublished: post.date,
    dateModified: post.updated ?? post.date,
    author,
    publisher: {
      '@type': 'Organization',
      name: 'BankStatementReader',
      logo: { '@type': 'ImageObject', url: `${SITE}/logo.png` },
    },
    mainEntityOfPage: { '@type': 'WebPage', '@id': abs(path) },
    keywords: post.tags.join(', '),
  }

  const breadcrumbs = breadcrumbJsonLd([
    { name: 'Home', path: '/' },
    { name: 'Blog', path: '/blog' },
    { name: post.categoryLabel, path: `/blog/category/${post.category}` },
    { name: post.title, path },
  ])

  return (
    <Seo
      title={`${post.title} | BankStatementReader`}
      description={post.description}
      canonicalPath={path}
      image={image}
      ogType="article"
      jsonLd={[blogPosting, breadcrumbs]}
    />
  )
}
